const formatter = new Intl.NumberFormat('en-US', {
  style: 'currency',
  currency: 'USD',
  minimumFractionDigits: 2,
})

const fraction = new Intl.NumberFormat('en-US', {
  style: 'currency',
  currency: 'USD',
  minimumFractionDigits: 0,
})

export const toUsdCurrency = (number: number) => {
  if (number % 1 === 0) return fraction.format(number)
  else return formatter.format(number)
}

export const formatDateTime = (milliseconds: number): string => {
  if (!milliseconds || Number.isNaN(milliseconds)) {
    return ''
  }

  const date = new Date(milliseconds)

  if (date.toString() === 'Invalid Date') {
    return ''
  }

  const options: Intl.DateTimeFormatOptions = {
    year: 'numeric',
    month: 'long',
    day: 'numeric',
  }

  return date.toLocaleDateString(undefined, options)
}

export const formatMapAddress = (data) => {
  const {
    address_components: addressComponents,
    geometry,
    place_id: gmaps_place_id,
  } = data

  const extractedData = {
    formatted: data.formatted_address,
    gmaps_place_id,
    address_1: '',
    locality: '',
    state: '',
    zip_code: '',
    latitude: geometry.location.lat(),
    longitude: geometry.location.lng(),
  }

  addressComponents.forEach((component) => {
    const { types, long_name, short_name } = component

    if (types.includes('street_number')) {
      extractedData.address_1 = long_name
    } else if (types.includes('route')) {
      extractedData.address_1 += ' ' + long_name
    } else if (types.includes('locality')) {
      extractedData.locality = long_name
    } else if (types.includes('administrative_area_level_1')) {
      extractedData.state = short_name
    } else if (types.includes('postal_code')) {
      extractedData.zip_code = long_name
    }
  })

  extractedData.address_1 = extractedData.address_1.trim()

  return extractedData
}

export const formatShortNumber = (number: string | number) => {
  if (number === null || number === undefined || Number.isNaN(Number(number))) {
    return 'NaN'
  }
  return Number(number).toLocaleString('en-US', {
    maximumFractionDigits: 1,
    notation: 'compact',
    compactDisplay: 'short',
  })
}

export const numberFormatter = (value: number | null | undefined) => {
  if (value === null || value === undefined || Number.isNaN(Number(value))) {
    return 'NaN'
  }
  return Number(value).toLocaleString('en-US')
}

export const slugifyText = (value: string | null | undefined): string => {
  if (!value) {
    return ''
  }
  return value
    .toLowerCase()
    .replace(/\s+/g, '-')
    .replace(/[^a-z0-9-]/g, '')
    .replace(/-+/g, '-')
    .replace(/^-|-+$/g, '')
}

export const truncateTitle = (
  title: string | null | undefined,
  maxLength: number
): string => {
  if (!title) return ''

  if (maxLength <= 0) return title

  const minLength = 4
  const actualMaxLength = Math.max(maxLength, minLength)

  if (title.length <= actualMaxLength) {
    return title
  }
  return title.slice(0, actualMaxLength - 3) + '...'
}
